<template>
<div id="app">

<!-- HEADER -->
<app-header v-if="propsdata[0]['account'] && propsdata[0]['verified'] && propsdata[0]['verified'].length === 50" :propsdata="propsdata"></app-header>
<!-- SIDEBAR -->
<sidebar-header v-cloak v-if="propsdata[0]['account'] && propsdata[0]['verified'] && propsdata[0]['verified'].length === 50 && ['index','bill-of-sale','lease-agreement','lease-termination-agreement','eviction-notice','financial-power-of-attorney','medical-power-of-attorney','child-power-of-attorney','revocation-power-of-attorney','last-will-and-testament','resignation-letter','recommendation-letter','llc-operating-agreement','non-disclosure-agreement','cease-and-desist-letter','business-contract','limited-power-of-attorney','prenuptial-agreement','divorce-settlement-agreement','independent-contractor-agreement','employment-contract'].includes($route.name)" :propsdata="propsdata" @togglesidebar="togglesidebar" @toggle_dropdowns="toggle_dropdowns"></sidebar-header>
<!-- MANAGE BAR -->
<manage-bar v-cloak v-if="propsdata[0]['account'] && propsdata[0]['verified'] && propsdata[0]['verified'].length === 50 && ['index','bill-of-sale','lease-agreement','lease-termination-agreement','eviction-notice','financial-power-of-attorney','medical-power-of-attorney','child-power-of-attorney','revocation-power-of-attorney','last-will-and-testament','resignation-letter','recommendation-letter','llc-operating-agreement','non-disclosure-agreement','cease-and-desist-letter','business-contract','limited-power-of-attorney','prenuptial-agreement','divorce-settlement-agreement','independent-contractor-agreement','employment-contract'].includes($route.name)" :propsdata="propsdata"></manage-bar>
<!-- ACCOUNT TABS -->
<account-header v-cloak v-if="propsdata[0]['account'] && propsdata[0]['verified'] && propsdata[0]['verified'].length === 50 && ['account','billing'].includes($route.name)" :propsdata="propsdata"></account-header>
<!-- CONTENT -->
<transition mode="out-in" name="anima">
<router-view v-if="propsdata[0]['account'] && propsdata[0]['verified'] && propsdata[0]['verified'].length === 50" :key="$route.fullPath" :propsdata="propsdata" @updateprops="update" @toggle_dropdowns="toggle_dropdowns" @open_modal_signup="open_modal_signup"></router-view>
<div v-if="propsdata[0]['account'] && !propsdata[0]['verified']" style="text-align:center;padding-top: 100px;">
<img src="/assets/img/deliver.svg" style="width:400px;max-width:100%;margin-bottom: 15px;">
<h1>Please verify your account</h1>
<p>We just emailed a confirmation link to <strong>{{propsdata[0]['email']}}</strong>.<br>Click the link and you will be signed in</p>
<br><br>
<p>Not your email? <a href="/login">Try again</a></p>
<p>Didn't receive an email? wait a few more seconds or <a href="mailto:support@documentify.com">Contact support</a></p>
</div>
</transition>

<!-- MODAL CREATE DOCUMENT -->
<div class="modal fade" id="modal-create" tabindex="-1" role="dialog" aria-labelledby="modal-create" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 1000px;">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title">Choose the document you want to create</h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div class="row" style="justify-content: space-evenly;">
                <div class="col-md-3">
                  <ul class="nav flex-column pt-3 pt-md-0 sidebar-top-mobile">
                    <p style="margin-left: 11px; margin-bottom: 0.8rem; font-weight: 900; color: rgb(42, 53, 79); font-size: 15px;">
                      <i class="fas fa-file" style="margin-right: 7px;"></i>Choose Document
                    </p>
                    <li class="nav-item" style="max-width: 100%;">
                      <a @click="create_document_type = 'Popular'" :class="{ 'active_create_type': create_document_type === 'Popular' }" class="nav-link collapsed d-flex justify-content-between align-items-center" style="font-size: 1rem;vertical-align: middle;padding: 0.55rem 0.75rem;border-radius: 0.2rem;margin-bottom: 0.2rem;">
                        <span>Popular Documents</span>
                      </a>
                    </li>
                    <li class="nav-item" style="max-width: 100%;">
                      <a @click="create_document_type = 'Business'" :class="{ 'active_create_type': create_document_type === 'Business' }" class="nav-link collapsed d-flex justify-content-between align-items-center" style="font-size: 1rem;vertical-align: middle;padding: 0.55rem 0.75rem;border-radius: 0.2rem;margin-bottom: 0.2rem;">
                        <span>Business</span>
                      </a>
                    </li>
                    <li class="nav-item" style="max-width: 100%;">
                      <a @click="create_document_type = 'Real Estate'" :class="{ 'active_create_type': create_document_type === 'Real Estate' }" class="nav-link collapsed d-flex justify-content-between align-items-center" style="font-size: 1rem;vertical-align: middle;padding: 0.55rem 0.75rem;border-radius: 0.2rem;margin-bottom: 0.2rem;">
                        <span>Real Estate</span>
                      </a>
                    </li>
                    <li class="nav-item" style="max-width: 100%;">
                      <a @click="create_document_type = 'Personal & Family'" :class="{ 'active_create_type': create_document_type === 'Personal & Family' }" class="nav-link collapsed d-flex justify-content-between align-items-center" style="font-size: 1rem;vertical-align: middle;padding: 0.55rem 0.75rem;border-radius: 0.2rem;margin-bottom: 0.2rem;">
                        <span>Personal & Family</span>
                      </a>
                    </li>
                    <li class="nav-item" style="max-width: 100%;">
                      <a @click="create_document_type = 'Employment'" :class="{ 'active_create_type': create_document_type === 'Employment' }" class="nav-link collapsed d-flex justify-content-between align-items-center" style="font-size: 1rem;vertical-align: middle;padding: 0.55rem 0.75rem;border-radius: 0.2rem;margin-bottom: 0.2rem;">
                        <span>Employment</span>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="col-md-9 row scrollbar_choosedocument" style="overflow: hidden auto;max-height: 450px;">
                  <div v-if="create_document_type === 'Business' || create_document_type === 'Popular'" class="col-md-6 pb-3">
                    <div class="pricing-card">
                      <div class="card shadow-soft border-primary p-0">
                        <header class="card-header bg-white p-3">
                          <h2 class="h5 text-primary mb-0">Bill of Sale</h2>
                        </header>
                        <div class="card-body p-0">
                          <p class="pl-3 pr-3">Record the sale of any item and protect both buyer and seller. </p>
                          <a href="/generate-bill-of-sale" tabindex="0" class="btn btn-primary btn-block" style="border-radius: 0px 0px 0.4rem 0.4rem; text-align: left;">Create Document <span class="fas fa-arrow-right" style="float: right; top: 4px; position: relative;"></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="create_document_type === 'Business'" class="col-md-6 pb-3">
                    <div class="pricing-card">
                      <div class="card shadow-soft border-primary p-0">
                        <header class="card-header bg-white p-3">
                          <h2 class="h5 text-primary mb-0">LLC Operating Agreement</h2>
                        </header>
                        <div class="card-body p-0">
                          <p class="pl-3 pr-3">Outlines the ownership and operating of a limited liability company. </p>
                          <a href="/generate-llc-operating-agreement" tabindex="0" class="btn btn-primary btn-block" style="border-radius: 0px 0px 0.4rem 0.4rem; text-align: left;">Create Document <span class="fas fa-arrow-right" style="float: right; top: 4px; position: relative;"></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="create_document_type === 'Business'" class="col-md-6 pb-3">
                    <div class="pricing-card">
                      <div class="card shadow-soft border-primary p-0">
                        <header class="card-header bg-white p-3">
                          <h2 class="h5 text-primary mb-0">Non-Disclosure Agreement</h2>
                        </header>
                        <div class="card-body p-0">
                          <p class="pl-3 pr-3">Legal contract prohibiting the disclosure of confidential information. </p>
                          <a href="/generate-non-disclosure-agreement" tabindex="0" class="btn btn-primary btn-block" style="border-radius: 0px 0px 0.4rem 0.4rem; text-align: left;">Create Document <span class="fas fa-arrow-right" style="float: right; top: 4px; position: relative;"></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="create_document_type === 'Business'" class="col-md-6 pb-3">
                    <div class="pricing-card">
                      <div class="card shadow-soft border-primary p-0">
                        <header class="card-header bg-white p-3">
                          <h2 class="h5 text-primary mb-0">Cease and Desist</h2>
                        </header>
                        <div class="card-body p-0">
                          <p class="pl-3 pr-3">Legal demand to stop harmful or illegal activity. </p>
                          <a href="/generate-cease-and-desist-letter" tabindex="0" class="btn btn-primary btn-block" style="border-radius: 0px 0px 0.4rem 0.4rem; text-align: left;">Create Document <span class="fas fa-arrow-right" style="float: right; top: 4px; position: relative;"></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="create_document_type === 'Business'" class="col-md-6 pb-3">
                    <div class="pricing-card">
                      <div class="card shadow-soft border-primary p-0">
                        <header class="card-header bg-white p-3">
                          <h2 class="h5 text-primary mb-0">Cease and Desist</h2>
                        </header>
                        <div class="card-body p-0">
                          <p class="pl-3 pr-3">Legal demand to stop harmful or illegal activity. </p>
                          <a href="/generate-cease-and-desist-letter" tabindex="0" class="btn btn-primary btn-block" style="border-radius: 0px 0px 0.4rem 0.4rem; text-align: left;">Create Document <span class="fas fa-arrow-right" style="float: right; top: 4px; position: relative;"></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="create_document_type === 'Business'" class="col-md-6 pb-3">
                    <div class="pricing-card">
                      <div class="card shadow-soft border-primary p-0">
                        <header class="card-header bg-white p-3">
                          <h2 class="h5 text-primary mb-0">Business Contract</h2>
                        </header>
                        <div class="card-body p-0">
                          <p class="pl-3 pr-3">Legal agreement between two or more persons or entities. </p>
                          <a href="/generate-business-contract" tabindex="0" class="btn btn-primary btn-block" style="border-radius: 0px 0px 0.4rem 0.4rem; text-align: left;">Create Document <span class="fas fa-arrow-right" style="float: right; top: 4px; position: relative;"></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="create_document_type === 'Real Estate' || create_document_type === 'Popular'" class="col-md-6 pb-3">
                    <div class="pricing-card">
                      <div class="card shadow-soft border-primary p-0">
                        <header class="card-header bg-white p-3">
                          <h2 class="h5 text-primary mb-0">Lease Agreement</h2>
                        </header>
                        <div class="card-body p-0">
                          <p class="pl-3 pr-3">Legal, binding contract to rent property owned by another party. </p>
                          <a href="/generate-lease-agreement" tabindex="0" class="btn btn-primary btn-block" style="border-radius: 0px 0px 0.4rem 0.4rem; text-align: left;">Create Document <span class="fas fa-arrow-right" style="float: right; top: 4px; position: relative;"></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="create_document_type === 'Real Estate' || create_document_type === 'Popular'" class="col-md-6 pb-3">
                    <div class="pricing-card">
                      <div class="card shadow-soft border-primary p-0">
                        <header class="card-header bg-white p-3">
                          <h2 class="h5 text-primary mb-0">Lease Termination Agreement</h2>
                        </header>
                        <div class="card-body p-0">
                          <p class="pl-3 pr-3">Document ending rental agreement between landlord and tenant. </p>
                          <a href="/generate-lease-termination-agreement" tabindex="0" class="btn btn-primary btn-block" style="border-radius: 0px 0px 0.4rem 0.4rem; text-align: left;">Create Document <span class="fas fa-arrow-right" style="float: right; top: 4px; position: relative;"></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="create_document_type === 'Real Estate' || create_document_type === 'Popular'" class="col-md-6 pb-3">
                    <div class="pricing-card">
                      <div class="card shadow-soft border-primary p-0">
                        <header class="card-header bg-white p-3">
                          <h2 class="h5 text-primary mb-0">Eviction Notice</h2>
                        </header>
                        <div class="card-body p-0">
                          <p class="pl-3 pr-3">Procedure by which a landlord may evict a tenant from their property. </p>
                          <a href="/generate-eviction-notice" tabindex="0" class="btn btn-primary btn-block" style="border-radius: 0px 0px 0.4rem 0.4rem; text-align: left;">Create Document <span class="fas fa-arrow-right" style="float: right; top: 4px; position: relative;"></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="create_document_type === 'Personal & Family' || create_document_type === 'Popular'" class="col-md-6 pb-3">
                    <div class="pricing-card">
                      <div class="card shadow-soft border-primary p-0">
                        <header class="card-header bg-white p-3">
                          <h2 class="h5 text-primary mb-0">Power of Attorney</h2>
                        </header>
                        <div class="card-body p-0">
                          <p class="pl-3 pr-3">The authority to act for another person in legal or financial matters. </p>
                          <a href="/generate-power-of-attorney" tabindex="0" class="btn btn-primary btn-block" style="border-radius: 0px 0px 0.4rem 0.4rem; text-align: left;">Create Document <span class="fas fa-arrow-right" style="float: right; top: 4px; position: relative;"></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="create_document_type === 'Personal & Family' || create_document_type === 'Popular'" class="col-md-6 pb-3">
                    <div class="pricing-card">
                      <div class="card shadow-soft border-primary p-0">
                        <header class="card-header bg-white p-3">
                          <h2 class="h5 text-primary mb-0">Last Will & Testament</h2>
                        </header>
                        <div class="card-body p-0">
                          <p class="pl-3 pr-3">Document specifying distribution of assets after a person's death. </p>
                          <a href="/generate-last-will-and-testament" tabindex="0" class="btn btn-primary btn-block" style="border-radius: 0px 0px 0.4rem 0.4rem; text-align: left;">Create Document <span class="fas fa-arrow-right" style="float: right; top: 4px; position: relative;"></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="create_document_type === 'Personal & Family'" class="col-md-6 pb-3">
                    <div class="pricing-card">
                      <div class="card shadow-soft border-primary p-0">
                        <header class="card-header bg-white p-3">
                          <h2 class="h5 text-primary mb-0">Prenuptial Agreement</h2>
                        </header>
                        <div class="card-body p-0">
                          <p class="pl-3 pr-3">Legal contract between two individuals who plan to marry. </p>
                          <a href="/generate-prenuptial-agreement" tabindex="0" class="btn btn-primary btn-block" style="border-radius: 0px 0px 0.4rem 0.4rem; text-align: left;">Create Document <span class="fas fa-arrow-right" style="float: right; top: 4px; position: relative;"></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="create_document_type === 'Personal & Family'" class="col-md-6 pb-3">
                    <div class="pricing-card">
                      <div class="card shadow-soft border-primary p-0">
                        <header class="card-header bg-white p-3">
                          <h2 class="h5 text-primary mb-0">Divorce Settlement Agreement</h2>
                        </header>
                        <div class="card-body p-0">
                          <p class="pl-3 pr-3">Legal contract between two individuals who plan to divorce. </p>
                          <a href="/generate-divorce-settlement-agreement" tabindex="0" class="btn btn-primary btn-block" style="border-radius: 0px 0px 0.4rem 0.4rem; text-align: left;">Create Document <span class="fas fa-arrow-right" style="float: right; top: 4px; position: relative;"></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="create_document_type === 'Employment' || create_document_type === 'Popular'" class="col-md-6 pb-3">
                    <div class="pricing-card">
                      <div class="card shadow-soft border-primary p-0">
                        <header class="card-header bg-white p-3">
                          <h2 class="h5 text-primary mb-0">Resignation Letter</h2>
                        </header>
                        <div class="card-body p-0">
                          <p class="pl-3 pr-3">A formal document expressing intent to leave a job position. </p>
                          <a href="/generate-resignation-letter" tabindex="0" class="btn btn-primary btn-block" style="border-radius: 0px 0px 0.4rem 0.4rem; text-align: left;">Create Document <span class="fas fa-arrow-right" style="float: right; top: 4px; position: relative;"></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="create_document_type === 'Employment' || create_document_type === 'Popular'" class="col-md-6 pb-3">
                    <div class="pricing-card">
                      <div class="card shadow-soft border-primary p-0">
                        <header class="card-header bg-white p-3">
                          <h2 class="h5 text-primary mb-0">Recommendation Letter</h2>
                        </header>
                        <div class="card-body p-0">
                          <p class="pl-3 pr-3">A document endorsing a person's skills and abilities for employment. </p>
                          <a href="/generate-recommendation-letter" tabindex="0" class="btn btn-primary btn-block" style="border-radius: 0px 0px 0.4rem 0.4rem; text-align: left;">Create Document <span class="fas fa-arrow-right" style="float: right; top: 4px; position: relative;"></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="create_document_type === 'Employment'" class="col-md-6 pb-3">
                    <div class="pricing-card">
                      <div class="card shadow-soft border-primary p-0">
                        <header class="card-header bg-white p-3">
                          <h2 class="h5 text-primary mb-0">Independent Contractor Agreement</h2>
                        </header>
                        <div class="card-body p-0">
                          <p class="pl-3 pr-3">Contract that lays out the terms of the independent contractor's work. </p>
                          <a href="/generate-independent-contractor-agreement" tabindex="0" class="btn btn-primary btn-block" style="border-radius: 0px 0px 0.4rem 0.4rem; text-align: left;">Create Document <span class="fas fa-arrow-right" style="float: right; top: 4px; position: relative;"></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="create_document_type === 'Employment'" class="col-md-6 pb-3">
                    <div class="pricing-card">
                      <div class="card shadow-soft border-primary p-0">
                        <header class="card-header bg-white p-3">
                          <h2 class="h5 text-primary mb-0">Employment Contract</h2>
                        </header>
                        <div class="card-body p-0">
                          <p class="pl-3 pr-3">Agreement between an employer and employee used to define the working relationship. </p>
                          <a href="/generate-employment-contract" tabindex="0" class="btn btn-primary btn-block" style="border-radius: 0px 0px 0.4rem 0.4rem; text-align: left;">Create Document <span class="fas fa-arrow-right" style="float: right; top: 4px; position: relative;"></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-link text-danger ml-auto" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- MODAL GUEST SIGN UP -->
<div v-show="modal_signup" style="display:none;position: fixed; top: 0; left: 0; z-index: 1050; width: 100%; height: 100%; overflow: hidden; outline: 0;">
  <div @click="close_modal_signup" style="position: fixed; left: 0; top: 0; width: 100%; height: 100%; background-color: rgba(40,50,80,.54); z-index: 10;"></div>
    <div class="modal-dialog modal-dialog-centered" style="max-width: 600px;z-index: 10;">
        <div class="modal-content">
            <div class="modal-header">
                <button @click="close_modal_signup" class="close">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body p-0">
              <div v-if="modal_signup">
                <div class="card bg-soft shadow-md border-0">
                <div class="card-header bg-white py-4">
                <div class="text-muted text-center mb-3">
                <div>
                  <h4>Download Your Document</h4>
                  <small style="font-size: 95%;">To ensure delivery give us your email address.</small>
                </div>
                </div>
                </div>
                <div class="card-body section-image position-relative" style="background: #f3f5f8;">
                <div class="form-group">
                <div class="input-group mb-4">
                <div class="input-group-prepend">
                <span class="input-group-text"><i class="far fa-envelope"></i></span>
                </div>
                <input v-model="email" class="form-control" placeholder="name@example.com" type="email" style="padding-left: 0.6rem;">
                </div>
                <small v-if="erroremail" class="text-white" style="display:block;font-size: 16px; color: #fb0202 !important; background: #fff; padding: 7px; border-radius: 3px; border: 1px solid #ff0000;">You have entered an invalid email address. Please try again.</small>
                <small v-if="usedemail" class="text-gray" style="display:block;font-size: 16px;">Email already registered. Use another one for this account.</small>
                </div>
                <div class="text-center">
                <button v-if="!creating" @click="create_account" class="btn btn-block btn-primary mt-4" style="z-index: 1;position: relative;">Submit</button>
                <button v-if="creating" class="btn btn-block btn-primary mt-4" style="z-index: 1;position: relative;"><i class="fa fa-spinner"></i> Loading</button>
                </div>
                </div>
                </div>
            </div>
            </div>
        </div>
    </div>
</div>

</div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      propsdata: [{
        account: this.$cookies.get("account"),
        verified: this.$cookies.get("verified"),
        email: '',
        name: '',
        unique_id: '',
        paid: '',
        cancel_at_period_end: '',
        canceled: '',
        cargado: false,
        path: '',
        document_slug: '',
        document_name: '',
        documents: [],
        loading_documents: false,
        documents_cargados: false,
        sidebar_mobile: false,
        dropdown1: false,
        dropdown2: false,
        dropdown3: false,
        dropdown4: false
      }],
      create_document_type: 'Popular',
      modal_signup: false,
      document_unique_id_to_download: 0,
      email: '',
      creating: false,
      erroremail: false,
      usedemail: false,
      cancelTokenSource: null
    }
  },
  methods: {
    update() {
      this.propsdata[0]['loading_documents'] = true;
      this.propsdata[0]['documents_cargados'] = false;
      this.propsdata[0]['path'] = this.$route.path;
      this.propsdata[0]['document_slug'] = this.$route.name;
      this.propsdata[0]['document_name'] = this.$route.name.replaceAll("-", " ").replace(/(^\w|\s\w)/g, m => m.toUpperCase());
      // Cancel the previous request, if it exists
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel('Request canceled');
      }

      // Create a new cancel token source
      this.cancelTokenSource = axios.CancelToken.source();

      // Make the Axios request with the new cancel token
      if(this.propsdata[0]['document_slug'] === 'index'){
        axios.post('/dashboard/cargar-documents.php', {
          }, {
          cancelToken: this.cancelTokenSource.token
          })
          .then(response => {
            this.propsdata[0]['documents'] = response.data;
            this.propsdata[0]['loading_documents'] = false;
            this.propsdata[0]['documents_cargados'] = true;
        })
          .catch(function (error) {
            console.log(error);
          });
      }
      else{
        axios.post('/dashboard/cargar-documents-by-type.php', {
          slug: this.propsdata[0]['document_slug']
          }, {
          cancelToken: this.cancelTokenSource.token
          })
          .then(response => {
            this.propsdata[0]['documents'] = response.data;
            this.propsdata[0]['loading_documents'] = false;
        })
          .catch(function (error) {
            console.log(error);
          });
      }
   },
   togglesidebar(){
     if(this.propsdata[0]['sidebar_mobile']){
       this.propsdata[0]['sidebar_mobile'] = false;
     }
     else{
       this.propsdata[0]['sidebar_mobile'] = true;
     }
  },
  toggle_dropdowns(num, text){
    if(num == 0){
      this.propsdata[0]['dropdown1'] = false;
      this.propsdata[0]['dropdown2'] = false;
      this.propsdata[0]['dropdown3'] = false;
      this.propsdata[0]['dropdown4'] = false;
    }
    if(num == 1){
      if(this.propsdata[0]['dropdown1'] && text != 'no_cerrar'){
        this.propsdata[0]['dropdown1'] = false;
      }
      else{
        this.propsdata[0]['dropdown1'] = true;
        this.propsdata[0]['dropdown2'] = false;
        this.propsdata[0]['dropdown3'] = false;
        this.propsdata[0]['dropdown4'] = false;
      }
    }
    if(num == 2){
      if(this.propsdata[0]['dropdown2'] && text != 'no_cerrar'){
        this.propsdata[0]['dropdown2'] = false;
      }
      else{
        this.propsdata[0]['dropdown2'] = true;
        this.propsdata[0]['dropdown1'] = false;
        this.propsdata[0]['dropdown3'] = false;
        this.propsdata[0]['dropdown4'] = false;
      }
    }
    if(num == 3){
      if(this.propsdata[0]['dropdown3'] && text != 'no_cerrar'){
        this.propsdata[0]['dropdown3'] = false;
      }
      else{
        this.propsdata[0]['dropdown3'] = true;
        this.propsdata[0]['dropdown1'] = false;
        this.propsdata[0]['dropdown2'] = false;
        this.propsdata[0]['dropdown4'] = false;
      }
    }
    if(num == 4){
      if(this.propsdata[0]['dropdown4'] && text != 'no_cerrar'){
        this.propsdata[0]['dropdown4'] = false;
      }
      else{
        this.propsdata[0]['dropdown4'] = true;
        this.propsdata[0]['dropdown1'] = false;
        this.propsdata[0]['dropdown2'] = false;
        this.propsdata[0]['dropdown3'] = false;
      }
    }
  },
  open_modal_signup(unique_id){
    this.modal_signup = true;
    this.document_unique_id_to_download = unique_id;
  },
  close_modal_signup(){
    this.modal_signup = false;
    this.document_unique_id_to_download = 0;
  },
  create_account(){
    this.creating = true;
    axios.post('/dashboard/add-email-to-guest.php', {
      email: this.email
      })
      .then(response => {
        if(response.data == 'error email'){
          this.erroremail = true;
          this.usedemail = false;
          this.creating = false;
            }
        else if(response.data == 'used email'){
          this.erroremail = false;
          this.usedemail = true;
          this.creating = false;
            }
        else{
          window.location.href = "/choose-plan/"+this.propsdata[0].unique_id+"?uid="+this.document_unique_id_to_download+"?utm_campaign=guest_registered";
        }
    })
      .catch(function (error) {
        console.log(error);
      });
  }
  },
  mounted(){
    localStorage.clear();
    if(!this.propsdata[0]['account']){
      //no esta logueado
      window.location.replace("https://documentify.com/login");
    }
    else if(!this.propsdata[0]['verified']){
      //no esta verificado
      axios.post('/dashboard/enviar-verificacion.php', {
        })
        .then(response => {
          this.propsdata[0]['email'] = response.data;
      })
        .catch(function (error) {
          console.log(error);
        });
    }
    else{
      axios.post('/dashboard/status.php', {
        })
        .then(response => {
          this.propsdata[0]['email'] = response.data[0].email;
          this.propsdata[0]['name'] = response.data[0].name;
          this.propsdata[0]['unique_id'] = response.data[0].unique_id;
          this.propsdata[0]['paid'] = response.data[0].paid;
          this.propsdata[0]['cancel_at_period_end'] = response.data[0].cancel_at_period_end;
          this.propsdata[0]['canceled'] = response.data[0].canceled;
          this.propsdata[0]['cargado'] = true;
      })
        .catch(function (error) {
          console.log(error);
        });
    }
}
  }
</script>

<style scoped>
.anima-enter{
  opacity: 0;
}
.anima-enter-active{
  transition: opacity 200ms;
  animation: slidein 200ms ease-out forwards;
}
.anima-leave{

}
.anima-leave-active{
  transition: opacity 200ms;
  opacity: 0;
  animation: slideout 200ms ease-out forwards;
}

@keyframes slidein {
  from{
    transform: translateY(-20px);
  }
  to{
    transform: translateY(0);
  }
}
@keyframes slideout {
  from{
    transform: translateY(0);
  }
  to{
    transform: translateY(20px);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue